import { z } from 'zod'
import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'

const formConfig = FormConfigLoader.loadFormConfig(formYaml)
export const FORM_CONFIG = formConfig

export const RetireDeviceFormSchema = z.object({
  deviceRetirementDate: z.string({
    message: "Date is required",
  }),
})

export type RetireDeviceFormData = z.infer<typeof RetireDeviceFormSchema>

export function transformToApiRequest(formData: RetireDeviceFormData, deviceNumber: number) {
  const retirementDate = formData.deviceRetirementDate
    ? Math.floor(new Date(formData.deviceRetirementDate).getTime() / 1000)
    : Math.floor(Date.now() / 1000)

  return {
    device: {
      deviceNumber,
      deviceStatus: "retired"
    },
    retirementInfo: {
      deviceNumber,
      deviceRetirementDate: retirementDate,
    }
  }
}
